const {
    _0PORT,
} = require('../../flowchart_port/FlowchartConnections/Myflowchart/PortTypes')

function scale(number, inMin, inMax, outMin, outMax) {
    return (
        ((Math.abs(number) - inMin) * (outMax - outMin)) / (inMax - inMin) +
        outMin
    )
}
function scaleServo(number, inMin, inMax, outMin, outMax) {
    return ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
}

const tokiExternalDigitalComponents = {
    // LED_blue: function (value) {
    //     return value
    // },
    // LED_green: function (value) {
    //     return value
    // },
    // LED_red: function (value) {
    //     return value
    // },
    // LED_white: function (value) {
    //     return value
    // },
    // laser_diode: function (value) {
    //     return value
    // },
}

const tokiExternalInputOutputComponents = {
    Analog_3_Pin_Input: function (value) {
        return value
    },
    Analog_2_Pin_Input: function (value) {
        return value
    },

    Digital_3_Pin_Input: function (value) {
        return value
    },
    Digital_2_Pin_Input: function (value) {
        return value
    },
    PWM_3_Pin_Output: function (value) {
        return value
    },
    PWM_2_Pin_Output: function (value) {
        return value
    },
    Digital_3_Pin_Output: function (value) {
        return value
    },
    Digital_2_Pin_Output: function (value) {
        return value
    },

    Magnetic_encoder: function (value) {
        return value
    },
    Magnetometer: function (value) {
        return value
    },
    IMU: function (value) {
        return value
    },
    Color_sensor: function (value) {
        return value
    },
    Audio_codec: function (value) {
        return value
    },
}

const robokiExtraAccessoriesValue = {
    tern_beeper: function (value) {
        return value
    },
    tern_humidity_sensor: function (value) {
        return value
    },
    tern_touch_sensor: function (value) {
        return value
    },
    tern_gas_sensor: function (value) {
        return value
    },
    tern_sound_sensor: function (value) {
        return value
    },
    tern_tact_switch: function (value) {
        return value
    },
}

export default {
    A: {
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ultrasonic_sensor: function (value) {
            return value
        },
        pcAiTool: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
        ...robokiExtraAccessoriesValue,
    },
    A1: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        pcAiTool: function (value) {
            return value
        },
        rain_sensor_module_analog: function (value) {
            return value
        },
        rain_sensor_module_digital: function (value) {
            return value
        },

        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
        ...robokiExtraAccessoriesValue,
    },
    A2: {
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        servo_extender: function (value) {
            return value
        },

        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        pcAiTool: function (value) {
            return value
        },
        rain_sensor_module_analog: function (value) {
            return value
        },
        rain_sensor_module_digital: function (value) {
            return value
        },
        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
        ...robokiExtraAccessoriesValue,
    },
    I2: {
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
    },
    I1: {
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
    },
    I: {
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
    },
    H2: {
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
    },
    H1: {
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
    },
    H: {
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
    },
    G2: {
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    G1: {
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    G: {
        '4_in_1_sensor': function (value) {
            return value
        },
        ultrasonic_sensor: function (value) {
            return value
        },
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    F2: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    F1: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    F: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    E2: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    E1: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    E: {
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    D2: {
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        mini_geared_motor: function (value) {
            return value
        },
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        geared_motor: function (value) {
            value = scale(value, 0, 10, 0, 100)
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    D1: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },

        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    D: {
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    C2: {
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        mini_geared_motor: function (value) {
            return value
        },
        geared_motor: function (value) {
            return value
        },
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        L293D_motor_driver: function (value) {
            return value
        },
        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
    },
    MOTOR1: {
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        relay: function (value) {
            return value
        },
        electromagnet: function (value) {
            return value
        },
    },
    MOTOR2: {
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        relay: function (value) {
            return value
        },
        electromagnet: function (value) {
            return value
        },
    },
    M1: {
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
        relay: function (value) {
            return value
        },
        electromagnet: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
    },
    M2: {
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
        relay: function (value) {
            return value
        },
        electromagnet: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
    },
    M3: {
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
        relay: function (value) {
            return value
        },
        electromagnet: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
    },
    M4: {
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
        relay: function (value) {
            return value
        },
        electromagnet: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
    },
    C1: {
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        L293D_motor_driver: function (value) {
            return value
        },
        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
    },
    C: {
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
    },
    B2: {
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },
        mini_geared_motor: function (value) {
            return value
        },
        geared_motor: function (value) {
            return value
        },
        stepper_motor: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
        ...robokiExtraAccessoriesValue,
    },
    B1: {
        stepper_motor: function (value) {
            return value
        },
        mp3: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },

        geared_motor: function (value) {
            return value
        },
        mini_geared_motor: function (value) {
            return value
        },
        dc_motor: function (value) {
            return value
        },
        //dynamex_motor map the value from 0 to 80
        dynamex_motor: function (value) {
            return Math.round(value * 0.8)
        },

        servo_extender: function (value) {
            return value
        },

        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
        ...robokiExtraAccessoriesValue,
    },
    B: {
        servo_extender: function (value) {
            return value
        },
        mp3: function (value) {
            return value
        },
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        dual_splitter: function (value) {
            return value
        },
        led: function (value) {
            return value
        },
        led_1c: function (value) {
            return value
        },
        laser: function (value) {
            return value
        },
        beeper: function (value) {
            return value
        },
        light_sensor: function (value) {
            return value
        },
        bend_sensor: function (value) {
            return value
        },
        gas_sensor: function (value) {
            return value
        },
        distance_sensor: function (value) {
            return value
        },
        sound_sensor: function (value) {
            return value
        },
        temperature_sensor: function (value) {
            return value
        },
        rain_sensor: function (value) {
            return value
        },
        rotational_sensor: function (value) {
            return value
        },
        accelerometer: function (value) {
            return value
        },
        solar_panel: function (value) {
            return value
        },
        humidity_sensor: function (value) {
            return value
        },
        hall_sensor: function (value) {
            return value
        },
        metal_detector: function (value) {
            return value
        },
        heartbeat_sensor: function (value) {
            return value
        },
        tact_switch: function (value) {
            return value
        },
        dual_switch: function (value) {
            return value
        },
        touch_sensor: function (value) {
            return value
        },
        pir_sensor: function (value) {
            return value
        },
        ...tokiExternalInputOutputComponents,
        ...robokiExtraAccessoriesValue,
        ...robokiExtraAccessoriesValue,
    },
    P0: {
        servo_motor: function (value) {
            return value
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
    },
    P1: {
        servo_motor: function (value) {
            return value
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
    },
    P2: {
        servo_motor: function (value) {
            return value
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
    },
    servo_motor1: {
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },

        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        ultrasonic_sensor: function (value) {
            return value
        },
        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
    },
    servo_motor2: {
        servo_motor: function (value) {
            return value
        },
        servo_motor_sg90: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_270: function (value) {
            return Math.round(0.667 * value)
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
        ultrasonic_sensor: function (value) {
            return value
        },
        ...tokiExternalDigitalComponents,
        ...tokiExternalInputOutputComponents,
    },
    O1: {
        servo_motor: function (value) {
            return value
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
    },
    O2: {
        servo_motor: function (value) {
            return value
        },
        servo_motor_360: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
    },
    PW1: {
        PWM: function (value) {
            return value
        },
    },
    PW2: {
        PWM: function (value) {
            return value
        },
    },
    PW3: {
        PWM: function (value) {
            return value
        },
    },
    PW4: {
        PWM: function (value) {
            return value
        },
    },
    PW5: {
        PWM: function (value) {
            return value
        },
    },
    PW6: {
        PWM: function (value) {
            return value
        },
    },
    serial_servo1: {
        serial_servo_motor: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
    },
    serial_servo2: {
        serial_servo_motor: function (value) {
            value = scaleServo(value, -100, 100, 0, 200)
            return value
        },
    },
}
